/**
 * React Query key factory — SEARCH keys (palette ⌘K globale).
 *
 * Référence centrale dans `queryKeys.ts` (barrel). SEARCH-002 §7.1.
 */

const searchAll = ['search'] as const

export const searchKeys = {
    search: {
        all: searchAll,
        global: (q: string, types?: string[]) =>
            [...searchAll, 'global', q, types ?? []] as const,
        preview: (type: string, id: string) =>
            [...searchAll, 'preview', type, id] as const,
        // Volet de synthèse — synthèse riche d'une fiche épinglée.
        summary: (type: string, id: string) =>
            [...searchAll, 'summary', type, id] as const,
    },
}
